import React from "react";
import Cookies from "universal-cookie";
import '../../../App.css';
import BarChart from "../Components/BarChart";
import CandleStickChart from "../Components/CandleStickChart";
import ChartCard from "../Components/ChartCard";
import DoughnutChart from "../Components/DoughnutChart";
import DoughnutChart2 from "../Components/DoughnutChart2";
import SeriesChart from "../Components/SeriresChart";


const cookies = new Cookies();
const MofReportDashboard =(props)=>{
   
        const goBack = () => {
            if (cookies.get("token") && cookies.get("user-type") && cookies.get("user-type") === '4')
                window.location.href = "/mof-dashboard"
            else
                window.location.href = "/"
        }

        if (cookies.get("token") && cookies.get("user-type") && cookies.get("user-type") === '4') {
            return (
                <div className={`mof-dashboard-div  ${props.inactive === false ? "activeSideMenu" : ""
            }`} style={{ color: '#2E5266FF',backgroundColor:'transparent' }}>
                    <div className="mof-dashboard-heading">
                        <div style={{ fontSize: 56 }}>مرحباً بك في لوحة التحكم </div>
                    </div>
                    
                    <div className="charts" >
                        <div className="chart-card">
                            <h2>المثال الاول</h2>
                        <BarChart/>
                        </div>
                        <div className="chart-card">
                        <h2>المثال الثاني</h2>
                        <DoughnutChart/>
                        </div>
                        <div className="chart-card">
                        <h2>المثال الثالث</h2>
                        <DoughnutChart2/>
                        </div>
                    </div>
                    <div className="charts" >
                        <div className="chart-card">
                            <h2>المثال الرابع</h2>
                        <CandleStickChart/>
                        </div>
                        <div className="chart-card" style={{flex:3}}>
                        <h2>المثال الخامس</h2>
                        <SeriesChart/>
                        </div>
                        
                    </div>
                    
                    <div onClick={() => goBack()} className="mof-dashboard-footer">
                        <div style={{ fontSize: 16,textAlign:'end' }}>الرجوع</div>
                    </div>
                </div>

            );
        } else {
            window.location.href = "/"
        }
    
}


export default MofReportDashboard;
